/**
 * Created by IMRANEXPT on 1/24/16.
 */
(function() {
    /** @ngInject */
    function productsPageController($scope, $state,$document,$timeout,$http){
        $scope.mandatory_error = false;
		$scope.products_amount = 0;
		$scope.required_product_error = false;
		$scope.takeaway_timelist = [];
		$scope.menu_page = false;
        $scope.all_products_mandatory = false;
		var groupProducts = [];
        $scope.empty_cart_error = false;
        var pairing_purchased = {};
		var product_types = [];
		var activeIndex = _.findIndex($scope.calendars, function(calendar){
            return !calendar.isNotSameMonth($scope.booking.date);
        });
        var giftcard = _.parseInt($scope.booking.meal.type) === 8;
        function initProducts(){
            $scope.booking.getProducts().then(function(){
                if(_.size($scope.booking.menu_products) > 0){
                    $scope.menu_page = true;
                }
                if(_.size($scope.booking.products) === 0 && _.size($scope.booking.menu_products) === 0) {
                    $state.go('guest-details', {}, {location: false});
                }else{
                    groupProducts = _.groupBy(_.filter($scope.booking.products, function(product){
                        return !product.is_paired;
                    }),'meal_type');
                    for(var t in groupProducts){
                        product_types.push(t);
                        if(_.size(groupProducts[t]) > 0){
                            var gpList =_.filter(groupProducts[t], {sync_child : 1});
                            if(gpList)
                                _.forEach(gpList,function(gt){
                                       for(var ip=1;ip<=$scope.booking.amount;ip++)
                                           $scope.incProduct(gt);
                            });
                        }

                        //break;
                    }
                }
            });
        }
        initProducts();

        $scope.takeawaySoldOut = function(){
            if($scope.booking.meal.type == 9){
                if(_.size($scope.takeaway_timelist) <= 0) return true;
            }
            return false;
        }
        $scope.getProductsList = function(){
            return $scope.menu_page ? $scope.booking.menu_products : groupProducts;
        };
        $scope.typeOpen = function(t){
            return _.includes(product_types, t);
        };
        $scope.toggleType = function(t){
            if(_.includes(product_types, t)){
                _.pull(product_types, t);
            }else{
                product_types.push(t);
            }
        };

        $scope.goNext = function(){
            $scope.mandatory_error = false;
            var mandatory_amount =  0;
            var has_mandatory =  false;
            $scope.empty_cart_error = false;
            if($scope.booking.meal.mandatory_products == true){
                $scope.all_products_mandatory = false;
                for(x in $scope.booking.products){
                    var prd = _.find($scope.booking.booking_products, {ID : $scope.booking.products[x].ID});
                    if($scope.booking.products[x].mandatory == 1 ){
                        if(!prd || $scope.booking.amount != prd.amount){
                            $scope.all_products_mandatory = true;
                        }
                    }
                }
                if($scope.all_products_mandatory == true) return false;
            }
            var required_ids = _.map(_.filter($scope.booking.products, {required : 1, is_paired : false}),'ID');
            if($scope.booking.meal.empty_cart_disallowed == 1 && _.size($scope.booking.booking_products) <= 0){
                $scope.empty_cart_error = true;
                return false;
            }
            for(x in $scope.booking.products){
                if($scope.booking.products[x].mandatory == 1) {
                    has_mandatory = true;
                    var prd = _.find($scope.booking.booking_products, {ID : $scope.booking.products[x].ID});
                    if(prd) {
                        mandatory_amount += prd.amount;
                    }
                }
            }

            if(has_mandatory && mandatory_amount < $scope.booking.amount) {
                $scope.mandatory_error = true;
                return false;
            }
            //check if all are mandatory
            for(x in $scope.booking.products){
                if(_.size(required_ids) > 0 && _.includes(required_ids,$scope.booking.products[x].ID)){
                    var prd = _.find($scope.booking.booking_products, {ID : $scope.booking.products[x].ID});
                    if(!prd){
                        $scope.required_product_error = true;
                        return false;
                    }
                }
            }
            //console.log("S");

            if(_.size($scope.booking.booking_products) == 0) {
                if($scope.booking.meal.type == 8 || $scope.booking.meal.type == 10 || $scope.booking.meal.type == 9){
                    alert($scope.booking.prod_lang.min_product_error);//"You must select a product to purchase");
                    return false;
                }else {
                    $state.go('guest-details', {}, {location: false});
                }
            }else {
                if($scope.booking.meal.type == 8  || $scope.booking.meal.type == 10){
                    $state.go('guest-details', {}, {location: false});
                } else {
                    if(_.sum(_.map($scope.booking.booking_products,'meal_price')) > 0) {
                        $state.go('confirm', {}, {location: false});
                    }else{
                        $state.go('guest-details', {}, {location: false});
                    }
                }
            }
        };
        $scope.$on("$viewContentLoaded", function() {
            updateWidgetStep('Products', {averageValue : $scope.booking.meal.avg_gtm_price, totalValue : ($scope.booking.meal.avg_gtm_price*$scope.booking.amount),meal : $scope.booking.meal.name,mealId : $scope.booking.meal.id, amount : $scope.booking.amount, date : $scope.booking.getDate('YYYY-MM-DD'), time : $scope.booking.time});
            if($scope.booking.groupEnabled()){
                $state.go('guest-details', {}, {location: false});
                return;
            }
            if($scope.booking.meal.type == 9) {
                $timeout(function () {
                    _.forEach(
                        document.querySelectorAll(".select-dropdown-container")
                        , function (el) {
                            if (el.classList.contains("disabled")) return;
                            _.forEach(el.querySelectorAll(".list"), function (lt) {
                                lt.addEventListener("click", function (e) {
                                    e.stopPropagation();
                                });
                            });
                            var lbl = el.querySelector('label');
                            lbl.addEventListener("click", function (e) {
                                e.stopPropagation();
                                if (el.classList.contains("show")) {
                                    el.classList.remove("show");
                                } else {
                                    hideDropDowns();
                                    el.classList.add("show");
                                }
                            });
                        });
                    $scope.setCalendars();
                    _initTime();
                    $scope.active_calendar = $scope.calendars[activeIndex];
                }, 0);
            }
        });

        $scope.calendar_next = function(e){
            activeIndex++;
            //console.log($scope.calendars.length, index);
            if(activeIndex > $scope.calendars.length) activeIndex = $scope.calendars.length-1;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        $scope.calendar_prev = function(e){
            //var activeIndex = getActiveCalendar();
            activeIndex--;
            if(activeIndex < 0) activeIndex = 0;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        $scope.setTime = function(time){
            $scope.booking.setTime(time);
            hideDropDowns();
        };
        $scope.setDate = function(date, calendar){
            $scope.booking.setTime('');
            if(calendar.isOffDay(date)) { return false; }
            if(calendar.isDisabled(date)) { return false; }
            if(calendar.isDisabledMonth(date)) { return false; }
            $scope.booking.setDate(date.format("YYYY-MM-DD"));
            initProducts();
            _initTime();
            hideDropDowns();
        };
        function hideDropDowns(){
            _.forEach(
                document.querySelectorAll(".select-dropdown-container.show"),
                function(el){
                    el.classList.remove("show");
                });
        }
        $document.on("click", hideDropDowns);
        $scope.$on("$destroy", function(){
            $document.off("click");
        });

        $scope.incProduct = function(product,primaryProduct){
            if(_.parseInt($scope.booking.meal.type) === 8){
                _.forEach($scope.booking.products, function(prd){
                    if(prd.ID !== product.ID)
                        prd.amount = 0;
                });
                _.remove($scope.booking.booking_products, function(prd){
                    return (prd.ID !== product.ID);
                });
            }
            var prd = _.find($scope.booking.booking_products, {ID : product.ID});
            if(product.max_qty > 0) {
                if (prd && prd.amount >= (product.max_qty-product.purchases)) {
                    alert("Produkten är tyvärr slutsåld");
                    return false;
                }
            }
            product.amount++;
            if(!_.isUndefined(primaryProduct)) {
                if (!_.has(pairing_purchased,primaryProduct.ID)){
                    pairing_purchased[primaryProduct.ID] = [{id : product.ID, amount : 1}];
                }else{
                    var _prd = _.find(pairing_purchased[primaryProduct.ID], {id : product.ID});
                    if(_prd) {_prd.amount++;}else{ pairing_purchased[primaryProduct.ID].push({id : product.ID, amount : 1});}
                }
                //console.log(pairing_purchased);
                //pairing_purchased[primaryProduct.ID].push({id : product.ID, amount : product.amount});

            }
            if(!prd)
                $scope.booking.booking_products.push(product);
			if($scope.booking.meal.type == 8) {
				$scope.products_amount = _.sumBy($scope.booking.booking_products,'amount');
			}
            if(product.pairing && product.sync_child == 1){
                _.forEach($scope.booking.getPairedProducts(product.pairing), function(p){
                   $scope.incProduct(p);
                });
            }
        };
        $scope.getPairedAmount = function(paired_product, product){
            if(_.has(pairing_purchased,product.ID)){
                var pf = _.find(pairing_purchased[product.ID],{id : paired_product.ID});
                if(pf) return pf.amount;
            }
            return 0;
            return paired_product.amount;
        };
        $scope.getPairProductTotal = function(product){
            if(product.amount == 0) return '';
            var total = product.meal_price*product.amount;
            if(!_.has(pairing_purchased,product.ID)) return total > 0 ? 'SEK ' + total : '';
            _.forEach(pairing_purchased[product.ID], function(p){
                var _prd = _.find($scope.booking.booking_products, {ID : p.id});
                if(_prd){
                    total += _prd.meal_price*p.amount;
                }
            });
            return total > 0 ? 'SEK ' + total : '';
            if(!product.pairing || product.amount <= 0) return '';
            var total = product.meal_price*product.amount;
            _.forEach($scope.booking.getPairedProducts(product.pairing), function(p){
                var _prd = _.find($scope.booking.booking_products,{ID : p.ID});
                if(_prd)
                    total += p.meal_price*_prd.amount;
            });
            return 'SEK ' + (total);
        };
        $scope.isSelectedProduct = function(product){
            //if(_.parseInt($scope.booking.meal.type) !== 8) return false;
            return _.find($scope.booking.booking_products, {ID : product.ID});
        };
        $scope.haveMenuProduct = function(){
            return _.find($scope.booking.booking_products, {meal_type : 'Menu'});
        }
        $scope.selectMenu = function(p){
            _.remove($scope.booking.booking_products, function(prd){
                return (prd.meal_type === 'Menu');
            });
            p.amount = 0;
            $scope.incProduct(p);
            //p.amount++;
            //$scope.booking.booking_products.push(p);
            //$scope.menu_page = false;
        }

        $scope.selectProduct = function(product){
            //if(_.parseInt($scope.booking.meal.type) !== 8) return false;
            //only work with gift cards

            //_.remove($scope.booking.booking_products, {qty_allowed : 0});
            var already_added = $scope.isSelectedProduct(product);
            if(giftcard) {
                $scope.booking.booking_products = [];
                _.forEach($scope.booking.products, function (prd) {
                    if (prd.ID !== product.ID)
                        prd.amount = 0;
                });
                if(already_added) return;
                product.amount = 1; //BUG HERE select-unselect product increase amount
                $scope.booking.booking_products.push(product);
                $scope.products_amount = _.sumBy($scope.booking.booking_products,'amount');
            }else{
                if(already_added){
                    $scope.decProduct(product);
                }else{
                    $scope.incProduct(product);
                }
            }
            //add this single product only

        };
        $scope.amountAllowed = function(check){
            //if(_.parseInt($scope.booking.meal.type) !== 8) return true;
            if(check != 1) return false;
            return true;
        };
        $scope.decProduct = function(product,primaryProduct){
            if(_.parseInt($scope.booking.meal.type) === 8){
                _.forEach($scope.booking.products, function(prd){
                    prd.amount = 0;
                });
                _.remove($scope.booking.booking_products, function(prd){
                    return (prd.ID !== product.ID);
                });
            }
            var prd = _.find($scope.booking.booking_products, {ID : product.ID});
            product.amount--;
            if(product.amount <= 0){
                if(prd){
                    _.remove($scope.booking.booking_products,function(p){
                        return p.ID == product.ID;
                    });
                }
                product.amount = 0;
            } else {
                if (!prd) {
                    $scope.booking.booking_products.push(product);
                }
            }
			if($scope.booking.meal.type == 8) {
				$scope.products_amount = _.sumBy($scope.booking.booking_products,'amount');
			}
            if(!_.isUndefined(primaryProduct) && _.has(pairing_purchased,primaryProduct.ID)) {
                var _pp = _.findIndex(pairing_purchased[primaryProduct.ID],{id : product.ID});
                if(_pp >= 0) {
                    pairing_purchased[primaryProduct.ID][_pp].amount = pairing_purchased[primaryProduct.ID][_pp].amount-1;
                    if(pairing_purchased[primaryProduct.ID][_pp].amount <= 0)
                        _.pullAt(pairing_purchased[primaryProduct.ID],_pp);
                }
            }
            if(product.pairing && product.sync_child == 1){
                _.forEach($scope.booking.getPairedProducts(product.pairing), function(p){
                    $scope.decProduct(p);
                });
            }
        };

        function _initTime(){
            $scope.booking.temp_booking_id = 0;
            var trequest = {
                date_code: date_code,
                date: $scope.booking.getDate("YYYY-MM-DD"),
                amount: $scope.booking.amount,
                mealid: $scope.booking.mealid,
                hd_meal : _.has(_widget_request,'hd_meal') ? _widget_request.hd_meal : (_.has($scope.alt_meal,'hd') ? $scope.alt_meal.hd : ''),
                hash: hash,
                int_test : int_test
            };
            $http.post("/booking-widget/api/getTimes", trequest).success(function (response) {
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    $scope.takeaway_timelist = response.times;
                    if(_.size(response.times) > 0){
                        for(var t in response.times){
                            $scope.booking.setTime(response.times[t][0]);
                            break;
                        }
                    }
                }
            });
        }
        $scope.disabledcontinue = function(){
            if($scope.booking.meal.type == 9){
                if(_.size($scope.takeaway_timelist) <= 0) return true;
            }
        };

    }
    angular.module("Waiteraid").controller("productsCtrl", productsPageController);
})();
